<template>
  <div class="messenger">
    <div class="messenger__list" ref="messangerList">
      <div
        :style="{ justifyContent: alignElement(message) }"
        class="msg-item"
        v-for="(message, index) of messeges"
        :key="index"
      >
        <div
          class="msg-item__avatar"
          :style="{ order: orderElement(message)[0] }"
        >
          <img
            class="user-avatar__img"
            :src="`${enterPoint.avatarUrl}/${message.from}.jpg`"
            onerror="this.onerror=null;this.style.display = 'none';"
          />
        </div>
        <div v-if="message.isLink" class="msg-item__text text-is-link">
          <span v-html="message.text"> </span>
        </div>
        <div v-if="!message.isLink" class="msg-item__text">
          <p :style="{ order: orderElement(message)[1] }">
            {{ textNormalize(message.text).text }}
          </p>
          <div v-if="textNormalize(message.text).links" class="msg-item__links">
            <span v-for="link in textNormalize(message.text).links" :key="link" class="text-is-link">
              <a :href="link">
                <i class="el-icon-download" />
                Скачать!
              </a>
            </span>
          </div>
          <p v-if="!isTeacher(message)" class="group-name">
            Группа: <strong>{{ message.group }}</strong>
          </p>
          <p v-if="!isTeacher(message)" class="student-name">
            Студент: <strong>{{ componentData.message_sender.name }}</strong>
          </p>
        </div>
      </div>
    </div>
    <div
      class="messenger__request-field"
      ref="requestField"
      contenteditable="true"
      @focus="placeholderShow = false"
      @blur="setPlaceholder()"
    ></div>
    <span class="messenger__text-placeholder" v-if="placeholderShow"
      >Ответить...</span
    >
    <button class="messenger__file-btn" @click="triggerFileInput">
      <i class="fas fa-paperclip"></i>
    </button>
    <input
      type="file"
      multiple
      ref="fileInput"
      style="display: none"
      @change="loadFile"
    />
    <button class="messenger__send-btn" @click="sendMessage()">
      <i class="fas fa-paper-plane"></i>
    </button>

    <add-file
      v-if="addFileShow"
      ref="addFile"
      :selected-chat="{ id: senderId }"
      @close="addFileShow = false"
      @sent="onFileSent"
    />
  </div>
</template>

<script>
import AddFile from './addFile.vue';

export default {
  name: "responseMessage",
  components: {
    AddFile,
  },
  data() {
    return {
      placeholderShow: true,
      messeges: [],
      addFileShow: false,
    };
  },
  props: {
    componentData: Object,
  },
  computed: {
    teacherData() {
      return this.$store.state.auth.user;
    },
    senderId() {
      return this.componentData.from;
    },
    enterPoint() {
      return this.$store?.state?.enterPoint;
    },
  },
  methods: {
    scrollBottom() {
      let blockScroll = this.$refs.messangerList;
      blockScroll.scrollTop = blockScroll.scrollHeight;
    },
    async fetchMessage() {
      await this.axios
        .get(`api/messages/${this.componentData.inc}`)
        .then((res) => {
          this.messeges = res.data.messages;
          let RegExp = /^\<a\shref\=\".*/;
          this.messeges.forEach((el) => {
            el.isLink = RegExp.test(el.text);
          });
        });
    },
    alignElement(value) {
      return Number(value.from) === this.teacherData.id
        ? "flex-start"
        : "flex-end";
    },
    orderElement(value) {
      return this.isTeacher(value) ? [0, 1] : [2, 1];
    },
    isTeacher(value) {
      return Number(value.from) === this.teacherData.id;
    },
    textNormalize(text) {

      let findElement = text.indexOf("#файлы#");
      let links = null;
      if (findElement !== -1) {
        links = text.match(/(https?:\/\/[^\s]+)/g);
        text = text.substr(0, findElement);
      }
      return { text, links };
    },
    sendMessage() {
      let obj = {
        text: this.$refs.requestField.innerText,
        recipient: this.senderId,
      };
      this.axios.post("api/messages", obj).then((res) => {
        if (res.data.status) {
          this.fetchMessage().then(() => {
            this.$refs.requestField.innerText = "";
            this.placeholderShow = true;
            this.scrollBottom();
          });
        }
      });
    },
    setPlaceholder() {
      this.$refs.requestField.innerText ? null : (this.placeholderShow = true);
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    loadFile() {
      const { files } = this.$refs.fileInput;
      if (files.length) {
        const filesCopy = [...files];
        this.addFileShow = true;
        this.$nextTick(() => {
          if (this.$refs.addFile) {
            this.$refs.addFile.addFile(filesCopy);
          }
        });
      }
      this.$refs.fileInput.value = '';
    },
    onFileSent() {
      this.addFileShow = false;
      this.fetchMessage().then(() => {
        this.scrollBottom();
      });
    },
  },
  mounted() {
    this.fetchMessage();
  },
};
</script>

<style lang="scss">
.messenger {
  position: relative;
  padding-bottom: 45px;
  height: 90%;
  .messenger__list {
    overflow-y: auto;
    height: 100%;
    padding: 10px 10px 60px 10px;
  }
  .msg-item {
    width: 100%;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    margin-bottom: 10px;
  }
  .msg-item__avatar {
    align-self: start;
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    background-color: lightgrey;
    border-radius: 50%;
    margin: 0 10px;
    overflow: hidden;
  }
  .msg-item__text {
    max-width: 500px;
    margin: 0;
    font-size: 14px;
    padding: 10px;
    border-radius: 15px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.4);
  }

  .msg-item__links {
    display: flex;
    flex-direction: column;
    row-gap: 5px;
  }

  .student-name {
    margin: 0;
  }
  .group-name {
    margin-top: 0;
    margin-bottom: 4px;
  }
  .student-name,
  .group-name {
    font-size: 12px;
    font-weight: 100;
    color: $secondary-text-clr;
  }
  .text-is-link {
    background-color: $brand-clr-1;
    gap: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: max-content;
    padding: 5px 10px;
    margin-bottom: 16px;
    border-radius: 10px;

    i {
      font-size: 20px;
      color: $basic-white;
    }

    a {
      display: flex;
      align-items: center;
      color: $basic-white;
    }
  }
  .el-textarea {
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .messenger__request-field {
    bottom: 0;
    right: 0;
    width: 100%;
    position: absolute;
    height: auto;
    border: 1px solid $secondary-text-clr;
    padding: 10px 70px 10px 10px;
    background-color: $basic-white;
    z-index: 6;
    outline: none;
    border-radius: 5px;
    &:focus {
      border-color: $brand-clr-1;
    }
  }

  .messenger__file-btn {
    cursor: pointer;
    position: absolute;
    right: 35px;
    bottom: 10px;
    z-index: 7;
    &:hover {
      i {
        color: lighten($color: $brand-clr-1, $amount: 10%);
      }
    }
    i {
      transition-duration: 0.3s;
      transition-property: color;
      color: $brand-clr-1;
      font-size: 20px;
    }
  }
  .messenger__send-btn {
    cursor: pointer;
    position: absolute;
    right: 5px;
    bottom: 10px;
    z-index: 7;
    &:hover {
      i {
        color: lighten($color: $brand-clr-1, $amount: 10%);
      }
    }
    i {
      transition-duration: 0.3s;
      transition-property: color;
      color: $brand-clr-1;
      font-size: 20px;
    }
  }
  .messenger__text-placeholder {
    font-size: 14px;
    position: absolute;
    left: 15px;
    bottom: 12px;
    z-index: 7;
    color: $secondary-text-clr;
  }
}
</style>
